import { render, staticRenderFns } from "./ReviewCustomerData.vue?vue&type=template&id=4031ad90&scoped=true&"
import script from "./ReviewCustomerData.vue?vue&type=script&lang=ts&"
export * from "./ReviewCustomerData.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewCustomerData.vue?vue&type=style&index=0&id=4031ad90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031ad90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
